import React from 'react'
import { connect } from 'react-redux'
import BusinessForm from './BusinessForm'

import {
  clear_business,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearBusiness: () => dispatch( clear_business() ),
  }
}

class ConnectedBusinessNew extends React.Component {
  componentWillMount() {
    this.props.clearBusiness()
  }

  render(){
    return <BusinessForm actionName="create"/>
  }
}

const BusinessNew = connect(mapStateToProps, mapDispatchToProps)(ConnectedBusinessNew)
export default BusinessNew



// WEBPACK FOOTER //
// ./src/js/components/BusinessNew.js